export default __webpack_public_path__ + "static/media/guaranteed.6b60c181.svg";